import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API } from 'aws-amplify';
import { ConfigService } from '../config';
import { ImpersonationToken } from './dev-impersonation.service';

export interface ImpersonateRequest {
	role: 'sadmin' | 'distiadmin' | 'marketadmin' | 'clientadmin' | 'campusadmin';
	distiId?: string | null;
	marketId?: string | null;
	clientId?: string | null;
	campusId?: string | null;
	portalView?: 'ops' | 'retail' | null;
}

export interface ImpersonateResponse {
	token: string;
	expiresIn: number; // seconds until expiration
}

@Injectable({
	providedIn: 'root'
})
export class DevImpersonationHttpService {
	constructor(private configService: ConfigService) {}

	/**
	 * Request impersonation from the backend
	 */
	impersonate(request: ImpersonateRequest): Observable<ImpersonationToken> {
		return new Observable((observer: any) => {
			const path = '/dev/impersonate';
			const params = {
				body: request
			};

			API.post(this.configService.get('host'), path, params)
				.then((result: { data?: ImpersonateResponse }) => {
					const response = result && result.data ? result.data : result as ImpersonateResponse;
					if (!response || !response.token || !response.expiresIn) {
						observer.error(new Error('Impersonation response missing token'));
						return;
					}

					const tokenData: ImpersonationToken = {
						token: response.token,
						role: request.role,
						distiId: request.distiId || null,
						marketId: request.marketId || null,
						clientId: request.clientId || null,
						campusId: request.campusId || null,
						portalView: request.portalView || 'ops',
						expiresAt: Math.floor(Date.now() / 1000) + response.expiresIn
					};

					observer.next(tokenData);
					observer.complete();
				})
				.catch((err) => {
					console.error('Impersonation error:', err);
					observer.error(err);
				});
		});
	}
}

